import { FC } from 'react';

type propsType = {
    errorDates: string | null;
    handleFile: (file: File) => void;
    loadingDates: boolean;
};

export const HTHInteractiveMapS13: FC<propsType> = ({ errorDates, handleFile, loadingDates }) => {

    return (
        <div className={'d-flex flex-wrap align-items-center gap-2 mt-2'}>
            <label className={'btn btn-outline-secondary btn-sm mb-0'}>
                Importar S-13 en Excel
                <input type={'file'}
                    accept={'.xlsx,.xls,.csv'}
                    style={{ display: 'none' }}
                    onChange={e => {
                        if (e.target.files && e.target.files[0]) {
                            handleFile(e.target.files[0]);
                        }
                    }}
                />
            </label>
            {loadingDates &&
                <span className={'text-info small ms-2'}>
                    Procesando archivo...
                </span>
            }
            {errorDates &&
                <span className={'text-danger small ms-2'}>
                    {errorDates}
                </span>
            }
        </div>
    );
}
